let baseURL;
let url = location.href;
let environment = '';
if(url.indexOf('http://localhost') != -1 || url.indexOf('sit') != -1 || url.indexOf('8081') != -1 ){
    environment = 'development';
}else{
    environment = 'production';
}

if(environment == "development"){
    baseURL='https://sever-test.yongxintao.com/'
    //baseURL = 'http://api.yxt.com/'
    //baseURL = 'https://server-order-api.yongxintao.com/';
}
else if(environment == "production"){
    baseURL='https://server-order-api.yongxintao.com/'
    //baseURL='https://sever-test.yongxintao.com/'
    //baseURL = 'http://api.yxt.com/'
}

export default baseURL;
